import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { computed } from '@ember/object';
import { DeviceCode as DeviceCodeProto } from '@square/dashboard-protos/models/squareup/devicesettings/external/device_code';
import { isPresent } from '@ember/utils';
import { DeviceProfileType as DeviceProfileTypeProto } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/shared/device_profile_type';
import { ProductType as DeviceCodeProductTypeProto } from '@square/dashboard-protos/models/squareup/devicesettings/product_type';
import { camelize, underscore } from '@square/dashboard-utilities/utils/keys';
import { DeviceProfileLink as DeviceProfileLinkProto } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/shared/device_profile_link';
export const Device = ProtoBaseModel.extend({
  computedId: computed('deviceCodeId', 'id', function () {
    return this.deviceCodeId ?? this.id;
  }),
  displayName: computed('deviceCodeName', 'name', function () {
    return this.name ?? this.deviceCodeName ?? '';
  }),
  id: attr(String),
  name: attr(String),
  locationId: attr(String),
  createdAt: attr(String),
  updatedAt: attr(String),
  // Device Code
  deviceCodeId: attr(String),
  deviceCode: attr(String),
  deviceCodeName: attr(String),
  deviceCodeStatus: attr(DeviceCodeProto.Status),
  deviceCodeProductType: attr(DeviceCodeProductTypeProto),
  deviceCodeLabelTranslationKey: computed('deviceCodeStatus', function () {
    return this.deviceCodeStatus === DeviceCodeProto.Status.PAIRED ? 'business.devices.profiles.v2.assignDevices.availableDevices.paired.label' : 'business.devices.profiles.v2.assignDevices.availableDevices.unpaired.label';
  }),
  isSignedInDevice: computed('id', function () {
    return isPresent(this.id);
  })
});
const DeviceProfileLink = ProtoBaseModel.extend({
  device: attr(Device),
  deviceProfileId: attr(String),
  deviceProfileType: attr(DeviceProfileTypeProto),
  deviceProfileName: attr(String)
}).reopenClass({
  fromProto(proto) {
    return DeviceProfileLink.deserialize(underscore(proto.toJSON()));
  },
  toProto(obj) {
    return DeviceProfileLinkProto.fromObject(camelize(obj.toJSON()));
  }
});
export default DeviceProfileLink;